import React from 'react';
import StatusBadge from '../common/StatusBadge';
import { Check, X, Trash2 } from 'lucide-react';
import { formatDateMoscow } from '../../utils/dateUtils';

const ReviewsMobileView = ({ reviews, onModerate, onDelete, loading }) => {
    const getRatingStars = (rating) => {
        return '⭐'.repeat(rating) + '☆'.repeat(5 - rating);
    };

    return (
        <div className="md:hidden space-y-4">
            {reviews.map((review) => (
                <div key={review.id} className="bg-white rounded-xl shadow-sm border border-slate-100 p-4">
                    <div className="flex justify-between items-start mb-2">
                        <div>
                            <div className="font-medium text-slate-800">
                                {review.user_fio || review.user_username || 'Неизвестно'}
                            </div>
                            {review.user_username && (
                                <div className="text-sm text-slate-500">@{review.user_username}</div>
                            )}
                        </div>
                        <StatusBadge status={review.status} />
                    </div>
                    
                    <div className="mb-2">
                        <div className="text-yellow-500 text-sm">{getRatingStars(review.rating)}</div>
                        <div className="text-xs text-slate-500">Оценка: {review.rating}/5</div>
                    </div>
                    
                    <div className="text-sm text-slate-700 mb-3">{review.text}</div>
                    
                    <div className="flex justify-between items-center text-xs text-slate-500 mb-3">
                        <span>
                            {formatDateMoscow(review.created_at)}
                        </span>
                        {review.is_admin && (
                            <span className="px-2 py-1 bg-purple-100 text-purple-800 rounded-full text-xs">Админ</span>
                        )}
                    </div>
                    
                    <div className="flex items-center gap-2 pt-2 border-t border-slate-100">
                        {review.status === 'pending' && (
                            <>
                                <button
                                    onClick={() => onModerate(review.id, 'approved')}
                                    className="flex-1 flex items-center justify-center gap-1 px-3 py-2 bg-green-50 text-green-600 rounded-lg hover:bg-green-100 text-sm font-medium"
                                >
                                    <Check size={16} /> Одобрить
                                </button>
                                <button
                                    onClick={() => onModerate(review.id, 'rejected')}
                                    className="flex-1 flex items-center justify-center gap-1 px-3 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 text-sm font-medium"
                                >
                                    <X size={16} /> Отклонить
                                </button>
                            </>
                        )}
                        <button
                            onClick={() => onDelete(review.id)}
                            className="px-3 py-2 bg-slate-50 text-slate-600 rounded-lg hover:bg-slate-100"
                        >
                            <Trash2 size={16} />
                        </button>
                    </div>
                </div>
            ))}
            {reviews.length === 0 && !loading && (
                <div className="p-8 text-center text-slate-500 bg-white rounded-xl">Отзывы не найдены</div>
            )}
        </div>
    );
};

export default ReviewsMobileView;
